import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
// `IAccountsView` now carries the optional MFA-challenge fields (`outcome`, `mfaPending`,
// `mfaMethods`), so the mutation's data surfaces a challenge as readily as the account `list`.
import { type IAccountsView } from '@shared/services';
import { checkCredentialsRequest, type CheckCredentialsRequestParams } from '../requests';

export const useCheckCredentialsMutation = (
  config?: SWRMutationConfiguration<IAccountsView, Error, string, CheckCredentialsRequestParams>,
) => {
  const { trigger, data, isMutating, error, reset } = useSWRMutation(
    'check-credentials-mutation',
    (_, { arg }: { arg: CheckCredentialsRequestParams }) => checkCredentialsRequest(arg),
    config,
  );

  return {
    checkCredentials: trigger,
    checkCredentialsData: data,
    isCheckingCredentials: isMutating,
    resetCheckCredentials: reset,
    checkCredentialsError: error,
  };
};
